/**
 * @generated SignedSource<<acead49753dc9debe18d4ebe60c192df>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
export type BrowseContentModuleBreadcrumbsColor = "DARK" | "LIGHT" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type sbBrowseContentModuleBreadcrumbsTone_browseContentModule$data = {
  readonly breadcrumbsColor?: BrowseContentModuleBreadcrumbsColor | null;
  readonly " $fragmentType": "sbBrowseContentModuleBreadcrumbsTone_browseContentModule";
};
export type sbBrowseContentModuleBreadcrumbsTone_browseContentModule$key = {
  readonly " $data"?: sbBrowseContentModuleBreadcrumbsTone_browseContentModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"sbBrowseContentModuleBreadcrumbsTone_browseContentModule">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "sbBrowseContentModuleBreadcrumbsTone_browseContentModule"
};

(node as any).hash = "5a37bc114c1019b7f7fbed5d21ab4c20";

export default node;
